import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

document.addEventListener("DOMContentLoaded", function () {
  const backToTop = document.querySelector(".back-to-top");

  if (!backToTop) return;

  const button = backToTop.querySelector(".back-to-top__tab") || backToTop;

  // Show/hide the tab based on scroll position.
  function toggleBackToTop() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const threshold = 300; // Show after scrolling 300px

    if (scrollTop > threshold) {
      backToTop.classList.add("active");
    } else {
      backToTop.classList.remove("active");
    }
  }

  // Smooth scroll to top.
  function scrollToTop(e) {
    e.preventDefault();

    gsap.to(window, {
      duration: 0.6,
      scrollTo: { y: 0 },
      ease: "power2.inOut",
    });
  }

  window.addEventListener("scroll", toggleBackToTop);
  button.addEventListener("click", scrollToTop);
  toggleBackToTop();
});
